export type ThemeChoice = `light` | `dark`;

export function readThemeChoice(): ThemeChoice {
  const s = typeof window === `undefined` ? null : localStorage.getItem(`theme`);
  return s === `dark` ? `dark` : `light`;
}

export function applyTheme(choice: ThemeChoice) {
  if (choice === `dark`) document.documentElement.dataset.theme = `dark`;
  else delete document.documentElement.dataset.theme;
}
